import { createSlice } from '@reduxjs/toolkit'
import { Dispatch } from 'redux'
import { AlertGroup, AlertTemplate } from '../../types/Alerts'
import { getValveAlertRules, getValveAlertTemplates } from '../../services/valve'
import { AxiosRequestConfig } from 'axios'

type ValveSliceState = {
  alertTemplates: AlertTemplate[]
  alertRules: AlertGroup[]
  loading: boolean
  error?: unknown
}

type SetAlertTemplatesAction = {
  type: string
  payload: AlertTemplate[]
}

type SetAlertRulesAction = {
  type: string
  payload: AlertGroup[]
}

type SetLoadingAction = {
  type: string
  payload: boolean
}

type SetErrorAction = {
  type: string
  payload: unknown | undefined
}

const initialState: ValveSliceState = {
  alertTemplates: [],
  alertRules: [],
  loading: false
}

const valveSlice = createSlice({
  name: 'valve',
  initialState,
  reducers: {
    setAlertTemplates(state, action: SetAlertTemplatesAction) {
      state.alertTemplates = action.payload
    },
    setAlertRules(state, action: SetAlertRulesAction) {
      state.alertRules = action.payload
    },
    setLoading(state, action: SetLoadingAction) {
      state.loading = action.payload
    },
    setError(state, action: SetErrorAction) {
      state.error = action.payload
    }
  }
})

export const { setAlertTemplates, setAlertRules, setLoading, setError } = valveSlice.actions

export function loadValveAlertTemplates(config?: AxiosRequestConfig) {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true))
      const templates = await getValveAlertTemplates(config)
      dispatch(setAlertTemplates(templates))
    } catch (error) {
      console.error(error)
      dispatch(setError(error))
    } finally {
      dispatch(setLoading(false))
    }
  }
}

export function loadValveAlertRules(id: string, config?: AxiosRequestConfig) {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true))
      dispatch(setAlertRules(await getValveAlertRules(id, config)))
    } catch (error) {
      console.error(error)
      dispatch(setError(error))
    } finally {
      dispatch(setLoading(false))
    }
  }
}

export default valveSlice.reducer
